<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="4" v-if="!user.estLimite">
        <v-card :to="{ name: 'me' }" height="320" class="link">
          <v-card-text class="text-center">
            <v-icon size="200" color="fournisseur">mdi-account</v-icon>
            <h3>Informations fournisseur</h3>
            <v-divider></v-divider>
            Mettez à jour les informations de votre entreprise: adresses,
            dirigeants et utilisateurs habilités.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card :to="{ name: 'demandes' }" height="320" class="link">
          <v-card-text class="text-center">
            <v-icon size="200" color="info">mdi-medical-bag</v-icon>
            <h3>Gestion des demandes</h3>
            <v-divider></v-divider>
            Gérez vos demandes, leur état, ou déposez une nouvelle demande au
            sujet de l'un de vos produits.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card :to="{ name: 'dispositifs' }" height="320" class="link">
          <v-card-text class="text-center">
            <v-icon size="200" color="produit">mdi-file-download</v-icon>
            <h3>Téléchargements</h3>
            <v-divider></v-divider>
            Téléchargez les fiches de vos dispositifs médicaux, ou les tables de
            références Euro-Pharmat.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.identite.fournisseur;
    },
  },
};
</script>

<style scoped>
.link:hover {
  transform: scale(1.04);
}
</style>
